import React from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';

function SmartQRestore(props) {

  const handleKeyDown = (event) => {
if (event.key === 'Enter') {
      props.onConfirmation();
    }
  };

  return (
    <BDialog disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogTitle>{TR.cm_restore_song_to_smartq}</DialogTitle>
      <DialogContent>

      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={props.onConfirmation}>{TR.cm_yes}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default SmartQRestore;